import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { RoleService } from '@core/services/authentication/role.service';
import { ROUTE_ROLES } from '@core/constants/roles/route-roles.constant';

export const roleGuard: CanActivateFn = (route) => {
  const roleService = inject(RoleService);
  const router = inject(Router);

  const path = route.routeConfig?.path;
  const requiredRoles = path ? ROUTE_ROLES[path] : undefined;
  if (!requiredRoles || requiredRoles.length === 0) {
    return true;
  }

  if (!roleService.hasAnyRole(requiredRoles)) {
    router.navigate(['app/dashboard']);
    return false;
  }

  return true;
};